export default __webpack_public_path__ + "static/media/portfolio-162.2d6a5d89.jpg";